import NotLoggedBaseScreen from '../../components/NotLoggedBaseScreen';
import { useSearchParams } from 'react-router-dom';
import { Wrapper } from './RegisterAccountActivationScreen.styles';
import { useBaseScreenHook } from '../../logic/core/base-screen.hook';
import Loader from '../../components/Loader';
import { useEffect, useState } from 'react';
import { activateAccount } from '../../logic/auth/auth';
import { AppRoutes } from '../../logic/core/routes';
import { getContactUrl } from '../../logic/core/externalLinks';

const RegisterAccountActivationScreen = () => {
    const [params] = useSearchParams();
    const {t, loading, setLoading, renderError, navigate, i18n} = useBaseScreenHook();
    const [errorScreen, setErrorScreen] = useState<boolean>(false);
    const [activated, setActivated] = useState<boolean>(false);

    useEffect(() => {
        const token = params.get('token');
        const accountId = params.get('accountId');
        if (accountId && token) {
            _activate(accountId, token);
        } else {
            setErrorScreen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    const _activate = (accountId: string, token: string) => {
        setLoading(true);
        activateAccount(accountId, token).then((res) => {
            setLoading(false);

            if (res.isFailure()) {
                setErrorScreen(true);
                return;
            }

            setActivated(true);
        });
    };

    return <NotLoggedBaseScreen>
        <Wrapper>
            <h2 className="title">
                {errorScreen
                    ? t('registerConfirmErrorScreen.title')
                    : activated
                        ? t('RegisterAccountActivationScreen.successTitle')
                        : t('RegisterAccountActivationScreen.title')}
            </h2>
            {loading ? <Loader/> : null}
            {activated ? (
                <>
                    <p>{t('RegisterAccountActivationScreen.successDescription')}</p>
                    <button className="button" style={{ marginTop: '20px' }} onClick={() => navigate(`/${AppRoutes.login}`)}>
                        {t('RegisterAccountActivationScreen.goToLogin')}
                    </button>
                </>
            ) : null}
            {errorScreen ? (
                <>
                    <p>{t('registerConfirmErrorScreen.description')}</p>
                    <strong>
                        {t('registerConfirm.needHelpInfo')}{' '}
                        <a href={getContactUrl(i18n.language)} target="_blank" rel="noopener noreferrer">
                            <strong>{t('registerConfirm.needHelpLink')}</strong>
                        </a>
                    </strong>
                </>
            ) : null}
            {renderError()}
        </Wrapper>
    </NotLoggedBaseScreen>;
};

export default RegisterAccountActivationScreen;
